import {
    FETCH_CREATE_ACTIVITY_DATA,
    FETCH_SKILLSET_TAGS,
    CREATE_ACTIVITY_REQUEST,
    FETCH_PROPERTY_LOCATION,
    FETCH_EDIT_ACTIVITY_DATA,
    FETCH_CLONE_ACTIVITY_DATA,
    UPDATE_ACTIVITY_REQUEST,
    FETCH_ASSIGNMENTMETHOD_TEAMMEMBERLIST,
    FETCH_ASSIGNMENTMETHOD_B2BLIST,
    FETCH_ASSIGNMENTMETHOD_CONTRACTLIST
} from "./actions/actionConstants";

import AppConstants from "../../../config/appConstants";

const mappingObject = {};

mappingObject[FETCH_CREATE_ACTIVITY_DATA] = {
    url: "/cact",
    mockdata: "cact.json",
    type: "file",
    method: AppConstants.httpMethod.GET
};


mappingObject[FETCH_SKILLSET_TAGS] = {
    url: "/actB2BSkillSet",
    mockdata: "actB2BSkillSet.json",
    type: "file",
    method: AppConstants.httpMethod.GET
};

mappingObject[FETCH_PROPERTY_LOCATION] = {
    url: "/getlocationbyzip",
    mockdata: "getlocationbyzip.json",
    type: "file",
    method: AppConstants.httpMethod.GET
};

mappingObject[CREATE_ACTIVITY_REQUEST] = {
    url: "/sa",
    mockdata: "sa.json",
    type: "file",
    method: AppConstants.httpMethod.POST
};

mappingObject[UPDATE_ACTIVITY_REQUEST] = {
    url: "/uptact",
    mockdata: "sa.json",
    type: "file",
    method: AppConstants.httpMethod.POST
};

mappingObject[FETCH_CREATE_ACTIVITY_DATA] = {
    url: "/cact",
    mockdata: "cact.json",
    type: "file",
    method: AppConstants.httpMethod.GET
};

mappingObject[FETCH_EDIT_ACTIVITY_DATA] = {
    url: "/edtact",
    mockdata: "sa.json",
    type: "file",
    method: AppConstants.httpMethod.GET
}

mappingObject[FETCH_CLONE_ACTIVITY_DATA] = {
    url: "/cloneact",
    mockdata: "cloneact.json",
    type: "file",
    method: AppConstants.httpMethod.GET
}

mappingObject[FETCH_ASSIGNMENTMETHOD_TEAMMEMBERLIST] = {
    url: "/gtk",
    mockdata: "tmList.json",
    type: "file",
    method: AppConstants.httpMethod.GET
}

mappingObject[FETCH_ASSIGNMENTMETHOD_B2BLIST] = {
    url: "/gbk",
    mockdata: "b2bLsit.json",
    type: "file",
    method: AppConstants.httpMethod.GET
}

mappingObject[FETCH_ASSIGNMENTMETHOD_CONTRACTLIST] = {
    url: "/gco",
    mockdata: "contractList.json",
    type: "file",
    method: AppConstants.httpMethod.GET
}

export default mappingObject;